const renderKey = (option) => {
  if (option._id) return option._id;

  return option;
};

const Select = ({ name, label, value, options, error, onChange, disableLabel = false }) => {
  return (
    <>
      <div className="mg-form-group">
        <select name={name} value={value} onChange={(e) => onChange(e)} className={`mg-custom-select ${name}`}>
          {label && (
            <option value="" disabled={disableLabel}>
              {label}
            </option>
          )}
          {options.map((option) => (
            <option key={renderKey(option)} value={renderKey(option)}>
              {option.name || option}
            </option>
          ))}
        </select>
        {error && <small className="mg-form-text mg-form-text--error">{error}</small>}
      </div>
    </>
  );
};

export default Select;
